import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Differentiator() {
  return <section className="py-20 bg-brand-teal text-white" data-id="element-5">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="text-center mb-16" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-gold mb-6" data-id="element-8">
            Por qué "esconder" verduras en muffins no sirve de nada.
          </h2>
          <p className="text-xl text-brand-light/90 max-w-3xl mx-auto" data-id="element-9">
            De nada sirven 200 recetas nutritivas si tu hijo tiene intestino
            permeable.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-10">
          {/* The Wrong Way */}
          <div className="bg-white/10 rounded-2xl p-8 border border-white/20 backdrop-blur-sm" data-id="element-11">
            <div className="flex items-center gap-3 mb-6" data-id="element-12">
              <XCircle className="w-8 h-8 text-red-400" data-id="element-13" />
              <h3 className="text-2xl font-bold" data-id="element-14">El Enfoque Tradicional</h3>
            </div>
            <p className="text-gray-300 mb-6" data-id="element-15">
              Si las paredes de su sistema digestivo tienen "agujeros",
              cualquier alimento mejorado se convierte en toxinas que viajan
              directo al cerebro.
            </p>
            <ul className="space-y-3 text-gray-300" data-id="element-16">
              <li className="flex items-start gap-2" data-id="element-17">
                <span className="text-red-400 mt-1" data-id="element-18">✕</span>
                Forzar alimentos que el cuerpo rechaza
              </li>
              <li className="flex items-start gap-2" data-id="element-19">
                <span className="text-red-400 mt-1" data-id="element-20">✕</span>
                Gastar fortunas en suplementos que no se absorben
              </li>
              <li className="flex items-start gap-2" data-id="element-21">
                <span className="text-red-400 mt-1" data-id="element-22">✕</span>
                Luchar en cada comida con llantos y crisis
              </li>
            </ul>
          </div>

          {/* The Right Way */}
          <div className="bg-white rounded-2xl p-8 border-2 border-brand-gold shadow-xl transform md:-translate-y-4" data-id="element-23">
            <div className="flex items-center gap-3 mb-6" data-id="element-24">
              <CheckCircle2 className="w-8 h-8 text-brand-teal" data-id="element-25" />
              <h3 className="text-2xl font-bold text-brand-teal" data-id="element-26">
                Nuestra Promesa
              </h3>
            </div>
            <p className="text-gray-700 mb-6 font-medium" data-id="element-27">
              Cuando sanamos la biología con nuestro protocolo, el niño deja de
              ser selectivo de forma natural.
            </p>
            <div className="bg-brand-light p-4 rounded-lg border border-brand-gold/30" data-id="element-28">
              <p className="text-xl font-serif font-bold text-brand-dark text-center italic" data-id="element-29">
                "No fuerces la comida, sana el terreno."
              </p>
            </div>
            <ul className="space-y-3 text-gray-700 mt-6" data-id="element-30">
              <li className="flex items-start gap-2" data-id="element-31">
                <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-32" />
                Desinflamación profunda del intestino
              </li>
              <li className="flex items-start gap-2" data-id="element-33">
                <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-34" />
                Apetito real por alimentos nutritivos
              </li>
              <li className="flex items-start gap-2" data-id="element-35">
                <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-36" />
                Paz en la mesa familiar
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}